import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export const DateFormatter = (props) => {
  moment.locale('br');
  return (
    <div
      className={props.className}
      style={{ width: 'max-content' }}
    >
      {props.value && moment(props.value).format('DD/MM/YYYY')}
    </div>
  );
};

DateFormatter.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string
};

DateFormatter.defaultProps = {
  value: null,
  className: ''
};

export const DatetimeFormatter = (props) => {
  return (
    <div
      className={props.className}
      style={{ width: 'max-content' }}
    >
      {props.value && moment(props.value).format('DD/MM/YYYY HH:mm:ss')}
    </div>
  );
};

DatetimeFormatter.propTypes = {
  value: PropTypes.instanceOf(Date),
  className: PropTypes.string
};

DatetimeFormatter.defaultProps = {
  value: null,
  className: ''
};

export const TimestampFormatter = (props) => {
  return (
    <div
      className={props.className}
      style={{ width: 'max-content' }}
    >
      {props.value && moment.unix(props.value / 1000).format('DD/MM/YYYY HH:mm:ss')}
    </div>
  );
};

TimestampFormatter.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string
};

TimestampFormatter.defaultProps = {
  value: 0,
  className: ''
};

export const TimeFormatter = (props) => {
  return (
    <div
      className={props.className}
      style={{ width: 'max-content' }}
    >
      {props.value && moment.unix(props.value / 1000).format('HH:mm')}
    </div>
  );
};

TimeFormatter.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string
};

TimeFormatter.defaultProps = {
  value: 0,
  className: ''
};

